<template>
  <div class="c-main-flex-1">
    <div class="o-layout">
      <div v-if="isLocal" class="o-layout__item">
        <div class="c-input--extra-info">
          <span v-html="$t('event.access-config.description')"></span>
        </div>
      </div>
      <div class="o-layout__item">
        <h3 class="c-title c-title--page-section">{{$t('urlBase')}}</h3>
        <a :href="host">{{host}}</a>
      </div>

      <div class="o-layout__item u-1-of-2-at-small">
        <div v-if="isLocal" class="o-layout">
          <div class="o-layout__item u-padding-top-large u-padding-bottom-medium">
            <h3 class="c-title c-title--page-section">{{$t('urlBase.config')}}</h3>
          </div>
          <div class="o-layout__item">
            <p><strong>{{$t('urlBase.urlList')}}</strong></p>
            <div class="c-list__body">
              <div v-for="url of config.urls" :key="url.address" class="c-list__row o-layout u-padding-horizontal-small">
                <div class="o-layout__item u-1-of-3">
                  <strong>{{url.address}}</strong>
                </div>
                <div class="o-layout__item u-1-of-3">
                  {{url.label}}
                </div>
                <div v-if="url.address !== config.localURL" class="o-layout__item u-1-of-3">
                  <sceButton label="select" class="c-button--primary c-button--small"
                             v-on:click="setURL(url.address)"/>
                  <sceButton icon="svg-symbols.svg#close" class="c-button--ghost c-button--small"
                             v-on:click="removeURL(url.address)"/>
                </div>
                <div v-else class="o-layout__item u-1-of-3">
                  <svg role="img" class="check">
                    <use xlink:href="images/check.svg#Symbols"></use>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="o-layout__item u-margin-top-medium">
            <p><strong>{{$t('urlBase.addURL')}}</strong></p>
            <div class="c-input c-input--text">
              <label class="c-input__label" for="addAddress">{{$t('addURL.address')}}</label>
              <input v-model="addURL.address" class="c-input__field" name="addAddress" type="text" id="addAddress"/>
            </div>
            <div class="c-input c-input--text">
              <label class="c-input__label" for="addLabel">{{$t('label')}}</label>
              <input v-model="addURL.label" class="c-input__field" name="addLabel" type="text" id="addLabel"/>
            </div>
            <div class="c-button c-button--primary c-button--large" v-on:click.prevent="saveURL()">
              {{$t('addURL.set')}}
            </div>
          </div>
        </div>
      </div>

      <div class="o-layout__item u-1-of-2-at-small">
        <event-passwords type="events" :typeId="$route.params.eventId" />
      </div>
    </div>
  </div>
</template>

<script>
import QRious from 'qrious'

import clone from 'lodash/cloneDeep'
import filter from 'lodash/filter'

import config from '@/config'

export default {
  name: "AccessConfig",
  components: {
    eventPasswords: () => import('@/components/eventPasswords.vue')
  },
  data: function() {
    return {
      judgeToken: null,
      url: '',
      addURL: {
        address: '',
        label: '',
      },
    }
  },
  computed: {
    isLocal: function() {
      return true
      // return this.$store.state.environment.local
    },
    host: function() {
      return this.$store.state.environment.baseUrl
    },
    config: function() {
      return this.$store.state.environment.config
    },
  },
  created: function () {
    this.initURL()
  },
  watch: {
    host: function() {
      this.updateURL()
    },
    url: {
      handler: function() {
        new QRious({
          size: 250,
          element: this.$refs.code,
          value: this.url,
        })
      },
      immediate: true
    }
  },
  methods: {
    saveURL: function() {
      const config = clone(this.config)
      config.urls.push({
        address: this.addURL.address,
        label: this.addURL.label,
      });
      config.localURL = this.addURL.address;
      console.log(config)

      this.updateConfig(config);
      this.addURL = {
        address: '',
        label: '',
      };
    },
    setURL: function(url) {
      const config = clone(this.config);
      config.localURL = url;

      this.updateConfig(config);
    },
    removeURL: function(url) {
      const config = clone(this.config);
      config.urls = filter(config.urls, item => item.address !== url);

      this.updateConfig(config);
    },
    updateConfig: function(newConfig) {
      newConfig.urls.forEach((url, i) => {
        url.id = i+1
      })
      this.$store.dispatch('environment.updateConfig', newConfig).then(() => this.initURL());
    },
    updateURL: function() {
      if (! this.judgeToken) {
        this.url = null
        return
      }

      const token = this.judgeToken.id
      const userId = this.judgeToken.userId
      this.url = this.host + '/#/login?userId=' + userId + '&token=' + token + '&destination=/judge/'
        + this.$route.params.eventId
    },
    initURL: function() {
      this.$http.get(config.root + '/events/' + this.$route.params.eventId + '/get-access-token',
        { params: { role: 'judge' }}).then((response) => {
        this.judgeToken = response.data
        this.updateURL()
      })
    },
  }
};
</script>

<style scoped>
.code {
  margin: 50px auto auto;
  display: block;
}

.check {
  height: 25px;
  width: 25px;
  fill: #4D59A1;
}
</style>
